<template>
    <div>
        <span>{{ $_.get(activity, 'actorUser.name') }} kullanıcısı "{{ $_.get(activity, 'payload.taskTitle') }}" adlı görevin açıklamasını güncelledi.</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskUpdateDescription",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>
<style scoped lang="scss"></style>
